export enum CashRegisterState {
    CLOSE = 0,
    OPEN = 1,
}

export type CashRegister = {
    caisseId: number;
    nomCaisse: string;
    etatCaisse: CashRegisterState;
    etatCaisseValide: boolean;
};
